var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
var SelectedTab = React.createContext(null);
/**
 * Base for tabs. Is not styles and is not intended to be used by itself
 */
export var BaseTabs = function (_a) {
    var classes = _a.classes, label = _a.label, children = _a.children, $value = _a.$value, value = _a.value, props = __rest(_a, ["classes", "label", "children", "$value", "value"]);
    return (React.createElement("label", { className: classes.tabs },
        label ? React.createElement("span", { className: "label" }, label) : null,
        React.createElement(SelectedTab.Provider, { value: $value }, children)));
};
export var Tab = function (_a) {
    var value = _a.value, children = _a.children, title = _a.title;
    var $value = React.useContext(SelectedTab).equals(value);
    var classes = 'tab';
    return (React.createElement("span", { className: $value.value ? 'selected ' + classes : classes, onClick: function (e) {
            e.stopPropagation();
            $value.set(true);
        } },
        title ?
            React.createElement("div", { className: "title" }, title)
            : null,
        React.createElement("div", { className: "body" }, children)));
};
//# sourceMappingURL=tabs.js.map